module.exports = __webpack_public_path__ + "img/gradeful.26970783.png";